export default [
    {name: "IslandViewer", path: "http://www.pathogenomics.sfu.ca/islandviewer/"},
    {name: "PSORTb v.3.0", path: "https://www.psort.org/psortb/index.html"},
    {name: "PSORTdb", path: "https://db.psort.org"},
    {name: "Pseudomonas Genome Database", path: "http://www.pseudomonas.com"},
    {name: "Burkholderia Genome Database", path: "http://www.burkholderia.com"},
];